import { Component, OnInit, HostListener, ViewChild, Inject, ElementRef } from '@angular/core';
import { Router } from "@angular/router";
import { superAdminService } from "../shared/services/superAdminService";
import { RestApiService } from "../shared/restApiServices/restapi.service";
import { GenericTableComponent, GtConfig, GtInformation, GtOptions} from '@angular-generic-table/core';
import { ShowToastyService } from "../shared/services/showToastyService";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ChangePasswordDialogComponent } from "../change-password-dialog/change-password-dialog.component";
import { ChangePlanModalComponent } from "../change-plan-modal/change-plan-modal.component";
import { UpdateBillingInfoModalComponent } from "../update-billing-info-modal/update-billing-info-modal.component";
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { GstinvoicedetailsComponent } from "../gstinvoicedetails/gstinvoicedetails.component";
import { PlanService } from 'app/shared/services/planService';
import { environment } from '../../environments/environment';
import { UpdateBasicInfoComponent } from 'app/update-basic-info/update-basic-info.component';
import { tutorialComponent } from 'app/tutorial/tutorialComponent';
import { SelectedQnrService } from 'app/shared/services/selected-qnr.service';
import { TabsDataService } from 'app/shared/services/tabs-data.service';
declare var amplitude: any;

@Component({
  selector: 'app-profile-component',
  templateUrl: './profile-component.component.html',
  styleUrls: ['./profile-component.component.css']
})
export class ProfileComponentComponent implements OnInit {

  notSupportedSize : boolean;
  selectedTab = '';
  imageChangedEvent: any = '';
  croppedImage: any = '';
  public configObject: GtConfig<any>;
  public configObject2: GtConfig<any>;
  public configObject3: GtConfig<any>;
  responsedata :any ;
  val1:any;
  userInfo = { 'email' : '' , 'type': '' , 'createdOn' : '', 'phoneNo': '' , 'Name' : '','imageUrl' : '',
  'companyName':''};
  editbaicinfo = false;
  updatedInfo = {'Name' : '' ,'email' : '' ,'phoneNo' : '', 'imageUrl' : '','companyName':''};

  ConfigOptions: GtOptions = {lazyLoad: true ,stack:false, highlightSearch:false, rowSelection:false,csvDelimiter:','};
  superAdminData = {};
  rightPanel:any;
  isShowGSTInvoice:boolean=false;
  updatesFreq = true; // weekly updates
  getUpdateCheck = false;
  checkout= false;
  showManagerTab = false;

  @ViewChild(GenericTableComponent)
  private myTable: GenericTableComponent<any, any>;
  public isAdmin : boolean = false;

  invitationColumns: string[] = ['organisation', 'owner', 'invitedOn','action'];
  invitationData : {organisation:string,owner:string,invitedOn:string,action:string,
                    superAdminId:string}[] = [];
  staticInvoiceData : {invoiceDate:string,action:string}[] = [];
  staticInvoiceColumns : string[] = ['invoiceDate','action'];
  userHeader: string = "";
  companyName_: string = "";
  switchOrgList:{orgName:string,superAdminID:string}[]=[];
  constructor(private superAdminService:superAdminService,private planService:PlanService, 
    private restApiService:RestApiService,private showToastyService:ShowToastyService, 
    private dialog:MatDialog,private router:Router,private el: ElementRef,
    private selectedQnrService: SelectedQnrService, private tabsDataService: TabsDataService) {
    this.userHeader = localStorage.getItem("user_name_header");
    this.companyName_ = localStorage.getItem('companyName');
    this.switchOrgList = this.restApiService.getSwitchOrgList();

    if (window.screen.width < 900) {
      // console.log("Screen size not supported");
      this.notSupportedSize = true;
    }
    else {
      this.notSupportedSize = false;
    }
    this.getData();

    this.configObject3 = {
      fields: [],
      settings: [],
      data: []
    };
    this.configObject3.info = {
      pageCurrent: 1,
      pageNext: 2,
      pagePrevious: null,
      pageTotal: 10,
      recordLength: 10,
      recordsAll: 100,
      recordsAfterFilter: 100,
      recordsAfterSearch: 13
    };
    this.restApiService.checkIfSuperAdmin().subscribe(
      result => {
        if (result.checkIfSuperAdmin == true) {
          this.showManagerTab = true;
          this.superAdminService.setData(this.showManagerTab);
        }
        else {
          this.showManagerTab = false;
          this.superAdminService.setData(this.showManagerTab);
        }
      });

   }

  ngOnInit() {
    // amplitude.getInstance().logEvent('test');
    this.getBillingInfo();
  }
  onSelectOrg(org:{orgName:string,superAdminID:string}){
    if(org && org.superAdminID && org.superAdminID != undefined && org.orgName && org.orgName){
      localStorage.setItem('superAdminID',org.superAdminID);
      localStorage.setItem('companyName',org.orgName);
      this.companyName_ = org.orgName;
      // this.restApiService.orgName.next(this.companyName_);
      this.getData();
      this.getBillingInfo();
      this.restApiService.checkIfSuperAdmin().subscribe(
        result => {
          if (result.checkIfSuperAdmin == true) {
            this.showManagerTab = true;
            this.superAdminService.setData(this.showManagerTab);
          }
          else {
            this.showManagerTab = false;
            this.superAdminService.setData(this.showManagerTab);
          }
        });
    }
  }

  companyName;
  gstNumber;
  Street1;
  Locality1;
  City1;
  Zipcode1;
  state1;
  Country1;
  getBillingInfo(){
    this.restApiService.getBillingDetails().subscribe(res=>{
      if(res.success == true){
        // res['address']['City'])
        this.companyName = res['company_name'];
        this.gstNumber = res['GSTIN'];
        if(Object.getOwnPropertyNames(res.address).length !== 0)
        {
          this.Street1 = res['address']['Street'];
          this.Locality1 = res['address']['Locality'];
          this.City1 = res['address']['City'];
          this.Zipcode1 = res['address']['Zipcode'];
          this.state1 = res['address']['state'];
          this.Country1 = res['address']['Country'];
        }
      }
    })
  }

  managerData;
  subscriptionEndDate= "";
  maxSurveyors;
  currentSurveyors;
  dataConsumed;
  planName;
  ownerEmail;
  showLoader = false;
  getData(){
    this.showLoader = true;
    this.restApiService.getPlanAndAccountDetailsOfUser().subscribe(res=>{
      if(res && res.success == true){
        this.managerData = res['managersData']['data'];
        this.selectedTab = 'account';
        this.responsedata = res.data[0];
        this.userInfo.email = res.userEmail;
        this.userInfo.type = this.showManagerTab?'Owner':'Manager';
        this.userInfo.companyName = res.data?res.data[0].company_name:'---';
        this.userInfo['mailVerified'] = res['mailVerified'];
        this.isAdmin = res.isAdmin;
        this.userInfo.createdOn = res.createdOn;
        this.userInfo.phoneNo = res.phone_number;
        this.userInfo.Name = res.Name;
        this.ownerEmail = res.data[0].userName;

        // if it is a manager we need to get manager invitation details
          this.getManagerInvitationList();
        // if(this.userInfo.type == 'Manager'){
        //   this.getManagerInvitationList();
        // }

        if(this.responsedata){
          this.subscriptionEndDate = this.responsedata.subscription_end_date;
          if(this.subscriptionEndDate && this.subscriptionEndDate.length>10
            && this.subscriptionEndDate.includes('T')){
            this.subscriptionEndDate = this.subscriptionEndDate.split('T')[0];
          }
          this.maxSurveyors = this.responsedata.max_devices_per_month;
          this.currentSurveyors = this.responsedata.active_devices_with_date? 
                                  this.responsedata.active_devices_with_date.length:0;
          this.dataConsumed = this.responsedata.data_consumed?this.responsedata.data_consumed/1000000:0;
          this.planName = this.responsedata.planName;

          if(this.maxSurveyors >0){
            this.progress = (this.currentSurveyors / this.maxSurveyors)*100;
          }
          let style:string  = `.dyanmicProgress{background: conic-gradient(#004A43 ${this.progress}%, #f2f2f4 ${this.progress}%)}`;
          this.progressBar(style);
        }
        if(this.responsedata.updateProgress == 0){
          this.updatesFreq = true;
          this.getUpdateCheck = false;
        }
        else if (this.responsedata.updateProgress == 1){
          this.updatesFreq = false;
          this.getUpdateCheck = true;
        }
        else{
          this.updatesFreq = true;
          this.getUpdateCheck = true;
        }
        if(res.imageUrl)
        {
          this.userInfo.imageUrl = res.imageUrl;
        }
        else{
          this.userInfo.imageUrl = '';
        }
        if(Boolean( res['adminData'])){
            this.superAdminData = res['adminData'][0];
        }

        if(this.isAdmin)
        {
          this.configObject = {
            fields: [
              {
                name: 'Device Id',
                objectKey: 'id',
                value: () => ''
              },
              {
                name: 'Device Name',
                objectKey: 'name',
                value: () => ''
              },
              {
                name: 'Last Sync Date',
                objectKey: 'date',
                value: () => ''
              }
            ],
            settings: [
              {
                objectKey: 'id',
                sort: 'asc',
                sortOrder: 1,
                columnOrder: 0
              },
              {
                objectKey: 'name',
                sort: 'asc',
                sortOrder: 1,
                columnOrder: 1
              },
              {
                objectKey: 'date',
                sort: 'asc',
                sortOrder: 0,
                columnOrder: 2
              }
            ],
            data: this.responsedata['active_devices_with_date']
          };

          this.configObject['info'] = {
            pageCurrent: 1,
            pageNext: 2,
            pagePrevious: null,
            pageTotal: 5,
            recordLength: 10,
            recordsAll: 100,
            recordsAfterFilter: 100,
            recordsAfterSearch: 13
          };

          this.configObject2 = {
            fields: [
              {
                name: 'User Id',
                objectKey: 'email'
              },
              {
                name: 'Password',
                value: () => '**********',
                objectKey: 'password'
              },
              {
                name: 'Action',
                objectKey: 'action',
                value: () => '',
                render: () =>
                '<div class="reset_text">Reset</div>',
                click: row =>
                  this.resetPassword(row)
              }
            ],
            settings: [
                   {
                    objectKey: 'email',
                    sort: 'asc',
                    sortOrder: 1,
                    columnOrder: 0
                  },
                  {
                    objectKey: 'password',
                    columnOrder: 1
                  },
                  {
                    objectKey: 'action',
                    columnOrder: 2
                  }
            ],
            data: res['managersData']['data']
          };
          this.configObject2.info = {
            pageCurrent: 1,
            pageNext: 2,
            pagePrevious: null,
            pageTotal: 5,
            recordLength: 10,
            recordsAll: 100,
            recordsAfterFilter: 100,
            recordsAfterSearch: 13
          };
        }

        if(res['invoicesData'].length > 0){
          this.isShowGSTInvoice = true;
          this.configObject3 = {
            fields: [
              {
                name: 'Invoice Date',
                objectKey: 'invoice_date',
                render:(row) => new Date(row.invoice_date).toDateString()
              },
              {
                name: 'Action',
                objectKey: 'action',
                value: () => '',
                render:(row) =>
                '<div class="reset_text">'+ (row.razorpay_invoice_id?row.razorpay_invoice_id :'View') + '</div>',
                click: row =>
                  this.viewInvoice(row)
              }
            ],
            settings: [
              {
                objectKey: 'invoice_date',
                columnOrder: 0
              },
              {
                objectKey: 'action',
                columnOrder: 1
              }
            ],
            data: res['invoicesData']
          };

          this.configObject3['info'] = {
            pageCurrent: 1,
            pageNext: 2,
            pagePrevious: null,
            pageTotal: 5,
            recordLength: 10,
            recordsAll: 100,
            recordsAfterFilter: 100,
            recordsAfterSearch: 13
          };
        }
      }
      this.showLoader = false;
    },error=>{
      this.showLoader = false;
    })
  }

  getManagerInvitationList(){
    this.restApiService.getManagerInvitationsList().subscribe(response=>{
      if(response && response.success && response.data){
        const data= response.data;
        this.invitationData = [];
        data.forEach(res=>{
          let invitedOn = res.timestamp?(res.timestamp*1000).toString():''; 
          let action = res.Status?res.Status:null;
          this.invitationData.push({organisation:res.org_name,owner:res.userName,invitedOn:invitedOn,
          action:action,superAdminId:res.superAdminID});
        });
      }
    });
  }

  acceptInvite(data) {
    // console.log("Accept Invitation");
    let superAdminID = data.superAdminId;
    this.restApiService.setadminStatus(superAdminID).subscribe(result => {
      if (result.success == true) {
        const index = this.invitationData.findIndex(x=> x.superAdminId == data.superAdminId);
        if(index != -1){
          this.invitationData[index].action = '1';
          const companyName = this.invitationData[index].organisation;
          let switchOrg:any = localStorage.getItem('switchOrg');
          if(switchOrg && switchOrg!= undefined){
            switchOrg = JSON.parse(switchOrg);
            if(switchOrg.findIndex(data=>data.superAdminID ==superAdminID ) == -1){
              switchOrg.push({orgName:companyName,superAdminID:superAdminID});
              localStorage.setItem('switchOrg',JSON.stringify(switchOrg));
            }
          }
          localStorage.setItem('superAdminID',superAdminID);
          localStorage.setItem('companyName',companyName);
          // this.restApiService.orgName.next(companyName);
        }
      }
    });
  }

  privacyPolicyHandler(event){
    this.selectedTab = 'privacyPolicy';
  }

  declinerequest(data) {
    // console.log("Decline Invitation");
    var superAdmin = data.superAdminId;
    this.restApiService.declineInviteRequestforManager(superAdmin).subscribe(result => {
      if (result.success == true) {
        const index = this.invitationData.findIndex(x=> x.superAdminId == data.superAdminId);
        if(index != -1){
          this.invitationData[index].action = '4';
        }
      }
    });
  }

  viewInvoice(row){
    if(environment.production)
    {
      window.open('https://invoices.razorpay.com/v1/l/' + row.razorpay_invoice_id);
    }
    else {
      window.open('https://invoices.razorpay.com/v1/t/' + row.razorpay_invoice_id);
    }
  }
  tabchange(val1)
  {
    if(val1 == 1)
    {
      amplitude.getInstance().logEvent('Account Details clicked');
    }
    else if(val1 == 2)
    {
      amplitude.getInstance().logEvent('User id & Password clicked');
    }
    else if(val1 == 3)
    {
      amplitude.getInstance().logEvent('Billing info clicked');
    }
  }
  editdetails(){
    amplitude.getInstance().logEvent('editdetailsbuttonclickedinuserprofile');
    this.editbaicinfo = true;
    this.updatedInfo = {'Name' : this.userInfo['Name'] ,'email' : this.userInfo['email'] ,'phoneNo' : this.userInfo['phoneNo'], 'imageUrl' : this.userInfo['imageUrl'],
    'companyName':this.userInfo['companyName']  };
    let dialogRef = this.dialog.open(UpdateBasicInfoComponent, {
      width: '800px',
      height: '400px',
      data: {'updatedInfo':this.updatedInfo, 'userInfo':this.userInfo, showManagerTab:this.showManagerTab},
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.showToastyService.success('Successfully updated' , 'Your info was updated.');
        this.getData();
      }
    });
  }

  showTutorial(){
    let dialogRef = this.dialog.open(tutorialComponent, {
      height: '82%',
      width: '76%'
    });
    dialogRef.afterClosed().subscribe(result => {
      this.rightPanel = false;
    });
  }

  progress = 0;
  progressBar(style) {

    // dyanmic progress bar
    const styleElement = document.createElement('style');
    styleElement.appendChild(document.createTextNode(style));
    this.el.nativeElement.appendChild(styleElement);
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 900) {
      this.notSupportedSize = true;
    }
    else{
      this.notSupportedSize=false;
    }
    // event.target.innerWidth;

  }

  public trigger = function ($event) {
    // console.log($event);
    switch ($event.name){
        case 'gt-page-changed-lazy':
            // this.getSurveyData(this.selectedQnrService.getQnr());
            break;
        case 'gt-sorting-applied':
            // console.log($event.value);
            break;
        default:
            // console.log($event);
            break;
    }
  };

  resetPassword(row){
    this.restApiService.forgotPasswordService(row.email).subscribe(
      result => {
        if (result.success) {
          this.showToastyService.success('Success' , 'Reset password link was successfully sent to manager - ' + row.email);
        }
        else {
          this.showToastyService.success('Failed' , result.value);
        }
      })
  }

  confirmDeleteModal(){
    let dialogRef = this.dialog.open(DeleteAccountDialogComponent, {
      height: '285px',
      width: '400px',
      data: { }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(result);
      if(result && result.success){
        this.restApiService.deleteAccount().subscribe(res=>{
          if(res.success == true){
            this.showToastyService.success('Account deleted' , 'Your account was successfully deleted.');
            this.restApiService.signOutService().subscribe(
              result => {
                //mahima - check commented text
                  this.superAdminService.setData(undefined);
                  // this.selectedQnrService.setQnr(null);
                  localStorage.removeItem('browserStorage');
                  localStorage.removeItem('superAdminID');
                  localStorage.removeItem('username');
                  localStorage.removeItem('user_name_header');
                  // this.tabsDataService.setSurveyTabDataTobeUpdated(true);
                  // this.tabsDataService.setSurveyorDataTobeUpdated(true);
                  // this.tabsDataService.setTeamsTabDataTobeUpdated(true);
                  // this.tabsDataService.setDateLevelAnalyticsDataTobeUpdated(true);
                  // this.tabsDataService.setDateUserAnalyticsDataTobeUpdated(true);
                  this.router.navigateByUrl('/logIn');
              });
          }
          else{
            this.showToastyService.failure('Error' , 'Couldn\'t delete account. Please try again later.');
          }
        })
      }
    });
  }
  clicked($event){
    amplitude.getInstance().logEvent('choosefileclickedinuserprofile');
    this.imageChangedEvent = event;
    // var files = $event.srcElement.files;
    // var reader = new FileReader();
    // // read the image file as a data URL.
    // reader.readAsDataURL(files[0]);

    // reader.onload =  (e) => {
    //     // get loaded data and render thumbnail.
    //     let image_url = e.target['result'];
    //     this.updatedInfo['imageUrl']  = image_url;
    //     // this.updatedInfo['imageUrl'] = image_url.replace(/^data:image\/[a-z]+;base64,/, "");
    // };
  }
  imageCropped(event: ImageCroppedEvent) {
    this.updatedInfo['imageUrl']  = event.base64;
}
imageLoaded() {
    // show cropper
}
cropperReady() {
    // cropper ready
}
loadImageFailed() {
    // show message
}
  changePassword(){
    let dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      width: '800px',
      data: {email : this.userInfo['email']}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.showToastyService.success('Password Updated.','')
      }
    });
  }

  // 0 - don't send updates, 1 - daily, 2- weekly
  setUpdatesFreq(event){
    // true - weekly  ------ false - daily
    this.updatesFreq = event.target.checked;
    if(this.updatesFreq){
      this.updateProgress(2);
    }
    else{
      this.updateProgress(1);
    }
  }

  onCheckedUpdates(value){
    // true - get updates
    this.getUpdateCheck = value;
    if(!this.getUpdateCheck){
      this.updateProgress(0);
      this.updatesFreq = true;
    }
    else{
      this.updateProgress(2);
    }
  }

  updateProgress(status){
    this.restApiService.setUpdateProgress(status).subscribe(
      result => {
        if (result.success) {
          let text ;
          if(status == 0){
            text = 'You will no longer get updates. Your subscription is inactive now.';
          } else if(status == 1){
            text = 'Your daily email subscription is active.';
          }
          else {
            text = 'Your weekly email subscription is active.';
          }
          this.showToastyService.success('Update successful' , text);
          if(status == 1){
            this.updatesFreq = false;
          }
          else{
            this.updatesFreq = true;
          }
        }
        else {
          this.showToastyService.failure('Failed' , result.msg);
        }
      });
  }

  onCancel(){
    amplitude.getInstance().logEvent('Cancelbuttonisclickedinuserprofile');
    this.editbaicinfo = false;
  }

  onSave(){
    amplitude.getInstance().logEvent('savebuttonisclickedinuserprofile');
    if(this.updatedInfo['Name'].length > 0 && this.updatedInfo['Name'].length > 0 && this.updatedInfo['Name'].length > 0)
    {
      if(this.updatedInfo['Name'] === this.userInfo['Name'])
      {
        this.updatedInfo['Name'] = null;
      }
      if(this.updatedInfo['email'] === this.userInfo['email'])
      {
        this.updatedInfo['email'] = null;
      }
      if(this.updatedInfo['phoneNo'] === this.userInfo['phoneNo'])
      {
        this.updatedInfo['phoneNo'] = null;
      }
      if(this.updatedInfo['companyName'] === this.userInfo['companyName'])
      {
        this.updatedInfo['companyName'] = null;
      }
      if(this.updatedInfo['imageUrl'] === this.userInfo['imageUrl'])
      {
        this.updatedInfo['imageUrl'] = null;
      }
      else{
        this.updatedInfo['imageUrl'] = this.updatedInfo['imageUrl'].replace(/^data:image\/[a-z]+;base64,/, "");
      }

      this.restApiService.updateUserInfo(this.updatedInfo['Name'],this.updatedInfo['email'],this.updatedInfo['phoneNo'], this.updatedInfo['imageUrl'],
      this.updatedInfo['companyName']).subscribe(res =>{
        this.editbaicinfo = false;
        if(res.success == true)
        {
          this.showToastyService.success('Successfully updated' , 'Your info was updated.')
          if(this.updatedInfo['email'] != null)
          {
            this.openVerficationModal();
          }
          this.getData();
        }
        else
        {
          console.log(res.err);
          this.showToastyService.failure('Server error' , res.err)
        }
      })
    }
  }

  openVerficationModal(){
    let dialogRef = this.dialog.open(VerfyMailIDComponent,{
      minWidth: '50rem',
      data: { email : this.userInfo['email']}
    })
    dialogRef.afterClosed().subscribe(res=>{
      if(res && res.success){
        this.getData();
      }
    })
  }

  openUpdateBillingInfoModal(){
    let dialogRef = this.dialog.open(UpdateBillingInfoModalComponent,{
      height: '330px',
      width: '800px',
      data: { email : this.userInfo['email']}
    })
  }


  openbillingdetailDialog()
  {
    let dialogRef = this.dialog.open(GstinvoicedetailsComponent,{
      width: '800px',
      height: '400px'
    })
    dialogRef.afterClosed().subscribe(res=>{
      if(res && res.success){
      }
    })

  }
  openChangePlanDialog(){
    let dialogRef = this.dialog.open(ChangePlanModalComponent,{
      width: '52%',
      height: '476px',
      data: {}
    })
    dialogRef.afterClosed().subscribe(res=>{
      if(res && res.checkout){
        this.checkout = true;
      }
      // console.log(res);
    })
  }

  cancelHandler(event){
    this.checkout = false;
  }

  navigateToDashBoard(){
    this.router.navigateByUrl('/questionnaires');
  }
  navigateToAccountDetails(){
    this.selectedTab == 'account';
    this.checkout = false;
  }
  signOut() {

    this.restApiService.signOutService().subscribe(
      result => {
        // if (result.success) {
          this.superAdminService.setData(undefined);
          this.selectedQnrService.setQnr(null,null);
          localStorage.removeItem('browserStorage');
          localStorage.removeItem('superAdminID');
          localStorage.removeItem('username');
          localStorage.removeItem('user_name_header');
          this.tabsDataService.setSurveyTabDataTobeUpdated(true);
          this.tabsDataService.setSurveyorDataTobeUpdated(true);
          this.tabsDataService.setTeamsTabDataTobeUpdated(true);
          this.tabsDataService.setDateLevelAnalyticsDataTobeUpdated(true);
          this.tabsDataService.setDateUserAnalyticsDataTobeUpdated(true);
          this.router.navigateByUrl('/logIn');
        // }
        // else {
        //   localStorage.removeItem('browserStorage');
        //   this.router.navigateByUrl('/logIn');
        // }
      });
  }

}

@Component({
  selector: 'verify-dialog',
  templateUrl: 'verify-dialog.html',
  styleUrls : ['./verify-dialog.css']
})
export class VerfyMailIDComponent {
  email: string;
  code: string;
  codeEmpty = '';
  failMsg: string = '';
  constructor(public dialogRef: MatDialogRef<VerfyMailIDComponent>, public restApiService: RestApiService, @Inject(MAT_DIALOG_DATA) public data: any, private showToastyService:ShowToastyService) {
    this.email = this.data.email;
  }

  onVerify() {
    if(!Boolean(this.code) || this.code.length < 1)
    {
      this.codeEmpty = 'on-error';
    }
    else{
      this.restApiService.confirmMailUpdate( null ,this.code).subscribe(result=>{
        if(result.success == true){
          this.showToastyService.success('Verfied' , '');
        }
        else{
          this.showToastyService.failure('Error' , 'Couldn\'t verify');
        }
        this.dialogRef.close(result);
      })
    }
  }

  onDiscard() {
    this.dialogRef.close({success : false});
  }
}


@Component({
  selector: 'delete-dialog',
  templateUrl: 'delete-dialog.html',
  styleUrls: ['delete-dialog.css']
})
export class DeleteAccountDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteAccountDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNo(): void {
    this.dialogRef.close({success: false});
  }

  onYes(){
    this.dialogRef.close({success: true});
  }
}



// WEBPACK FOOTER //
// ./src/app/profile-component/profile-component.component.ts